import { render, staticRenderFns } from "./riesgosModificableShow.vue?vue&type=template&id=cc260794&scoped=true&"
import script from "./riesgosModificableShow.vue?vue&type=script&lang=js&"
export * from "./riesgosModificableShow.vue?vue&type=script&lang=js&"
import style0 from "./riesgosModificableShow.vue?vue&type=style&index=0&id=cc260794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc260794",
  null
  
)

export default component.exports